import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { MainInput, MainButton } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";
import { isValidProjectName, isValidUrls } from "../../utils/stringFormat";

export default function ProjectCreateModal({
    open,
    onClose,
    script,
    onFinish,
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 300,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };
    const [nameError, setNameError] = useState(false);
    const [sitemapError, setSitemapError] = useState(false);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        setNameError(false);
        setSitemapError(false);
        setDisabled(false);
    }, [open]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const name = data.get("name");
        const sitemap = data.get("sitemap");
        var isValid = true;
        if (!isValidProjectName(name)) {
            setNameError(true);
            isValid = false;
        } else {
            setNameError(false);
        }
        if (!isValidUrls(sitemap)) {
            setSitemapError(true);
            isValid = false;
        } else {
            setSitemapError(false);
        }
        if (!isValid) {
            return;
        }
        setDisabled(true);
        onFinish({ name, sitemap });
    }
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Typography id="modal-project-create-title" variant="h6" component="h2" fontWeight={"bold"}>
                    Create a new project
                </Typography>
                <Box component={"form"} onSubmit={handleSubmit} noValidate mt={"1.5rem"}>
                    <Stack direction={"column"} spacing={"1.25rem"}>
                        <MainInput name="name" type="text" placeholder="Enter Project Name" required
                            key="name"
                            error={nameError}
                            helperText={nameError ? "Project name must be text and numbers" : ""}
                        />
                        <MainInput
                            key="sitemap"
                            name="sitemap" type="textarea"
                            placeholder={`Paste your Website XML Sitemap URL(s), e.g.\nhttps://yoursite.com/sitemap_collections.xml\nhttps://yoursite.com/sitemap_products.xml\nhttps://yoursite.com/sitemap_pages.xml`}
                            required
                            error={sitemapError}
                            helperText={sitemapError ? "Sitemap URL must be a valid XML sitemap URL" : ""}
                        />
                        <Typography variant="body2" fontWeight={550}>Paste this code in the &lt;head&gt; section of your 404 Page
                            Template</Typography>
                        <Box
                            sx={{
                                border: `1px solid ${Constants.Colors[mode].border}`,
                                padding: "1rem",
                                borderRadius: 2,
                                backgroundColor: alpha(Constants.Colors[mode].secondary, 0.5),
                                position: "relative"
                            }}
                        >
                            <Typography variant="body1">{script}</Typography>
                            <Box sx={{
                                position: "absolute",
                                top: "1rem",
                                right: "0.5rem",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                                "&:hover": {
                                    backgroundColor: Constants.Colors[mode].success,
                                },
                                padding: "3px",
                                cursor: "pointer",
                            }} onClick={() => {
                                navigator?.clipboard?.writeText(script).then(function () {
                                    console.log("Script copied to clipboard");
                                }, function (err) {
                                    console.error("Error copying script to clipboard:", err);
                                });
                            }}>
                                <ContentCopyOutlinedIcon sx={{

                                    fontSize: 20,
                                    color: Constants.Colors[mode].mutedForeground,
                                }} />
                            </Box>
                        </Box>
                        <Stack direction={"row"} justifyContent={"flex-end"}>
                            <MainButton type="submit" text="Create" size="medium" fullWidth={false} disabled={disabled} isSubmitting={disabled} />
                        </Stack>
                    </Stack>
                </Box>
            </Box>
        </Modal>
    );
}